<template>
  <div 
    class="tour-360 josh-js"
    data-josh-anim-name="fadeIn"
    data-josh-duration="1500ms"
  >
    <div class="tour-360__content">
      <SectionHeader invert>360 tour</SectionHeader>
      <div 
        class="josh-js"
        data-josh-anim-name="fadeInRight"
        data-josh-duration="1500ms"
      >
        <HMTTour360Provider />
      </div>
    </div>
  </div>
</template>

<script>
  import Josh from 'joshjs';

  import HMTTour360Provider from '@/shared/components/Tour360Provider';
  import SectionHeader from '../../components/SectionHeader';

  export default {
    name: 'Tour360',
    components: {
      HMTTour360Provider,
      SectionHeader,
    },
    mounted () {
      // eslint-disable-next-line
      const josh = new Josh();
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .tour-360 {
    background-color: #1A1C21;

    &__content {
      @include layoutContent();
      @include layoutHPadding();
      @include layoutVPadding();
    }
  }
</style>
